import React from 'react';
import {useAuthDispatch, useAuthState} from '../../Context/AuthProvider/AuthProvider';
import {LoginLayout} from '../../Layouts/LoginLayout';
import { LoginForm } from 'src/Components/Form/LoginForm';
import {useParameterizedQuery} from 'react-fetching-library';
import {getZendeskToken} from '../../Actions/ZendDeskTokenActions/ZendeskTokenActions';
import {ValidateEmailZD} from './ValidateEmailZD';
import {EmptyState} from '../../Components/EmptyState';
import {LoginPayloadRequest, loginUser} from '../../Context/AuthProvider/AuthProviderActions';
import {addAlert} from '../../Context/AlertProvider/AlertProviderActions';
import {useAlertDispatcherState} from '../../Context/AlertProvider/AlertProvider';
import {useAuth0} from '@auth0/auth0-react';
import {Auth0LogoutButton} from '../../Components/Form/Auth0LogoutButton';


export const ZendeskSSO : React.FunctionComponent = (_props) => {
    const loginTitle='Login Requerido';
    const loginSubtitle='Es necesario iniciar sesión para poder continuar.';
    const textContent='Para poder acceder al módulo de Soporte, es necesario que inicie sesión en el sistema.';

    const {token, user} = useAuthState();
    const [sendPetition, setSendPetition] = React.useState<boolean>(false);
    const [hasLogin, setHasLogin] = React.useState<boolean>(false);

    const queryParameters = new URLSearchParams(window.location.search);
    const returnTo = queryParameters.get('return_to');

    const getTokenZ = useParameterizedQuery( getZendeskToken );

    const [validCompany, setValidCompany] = React.useState<string>('');
    const [useAut0, setUseAut0] = React.useState<boolean>(false);

    const { loginWithRedirect } = useAuth0();

    const isFormatEmail = React.useMemo( () => {
        const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if( user !== undefined && user.email !== undefined ){
            return (user.email.match(validRegex) !== null);
        }
        return false;
    }, [user] );

    React.useEffect( () => {
        setHasLogin ( token !== undefined && token !== '');
        setSendPetition(true );
    }, [token] );

    React.useEffect( () => {
        if( hasLogin && sendPetition && isFormatEmail && user !== undefined && user.mail_validado ){
            setSendPetition(false);

            getTokenZ.query({}).then( (res) => {
                if( res.payload !== undefined ){
                    const payload = res.payload;

                    if( !payload.error['has-error'] ){
                        const response = payload.response;
                        let url = `${response.endpoint}?jwt=${response.jwt_token}`;

                        if( returnTo !== null ){
                            url = `${url}&return_to=${encodeURIComponent(returnTo)}`;
                        }

                        window.location.replace(url);
                    }
                }
            } );
        }
    }, [hasLogin, sendPetition, returnTo, getTokenZ, isFormatEmail, user] );

    const dispatch = useAuthDispatch();
    const alertDispatch = useAlertDispatcherState();

    const handleBasicLogin = React.useCallback( async (payload:LoginPayloadRequest)=>{
        try {
            const responseLogin = await loginUser(payload, dispatch);
            if (!responseLogin || !responseLogin.response || !responseLogin.response.user || responseLogin.response.user.id <= 0) return;

            addAlert('Autentificación exitosa', `Bienvenido ${ responseLogin.response.user.clave }` ,'success', alertDispatch );
        } catch (error) {
            console.log(error);
        }
    }, [alertDispatch, dispatch] );

    const handleAuth0Login = React.useCallback( () => {
        loginWithRedirect({
            appState: {
                company:validCompany,
                action: 'zendesk',
            }
        });
    }, [loginWithRedirect, validCompany]);

    React.useEffect( () => {
        if (useAut0){
            handleAuth0Login();
        }
    }, [handleAuth0Login, useAut0, validCompany]);



    if ( hasLogin && user !== undefined ){
        if ( !user.mail_validado || !isFormatEmail ){
            return (
                <LoginLayout loginTitle={loginTitle}
                             loginSubtitle={'Es necesario validar su correo electrónico para poder continuar.'}
                             textContent={textContent}
                >
                    <ValidateEmailZD />
                </LoginLayout>
            );
        }

        return (
            <LoginLayout loginTitle={loginTitle}
                         loginSubtitle={loginSubtitle}
                         textContent={textContent}
            >
                <EmptyState loading/>
            </LoginLayout>
        );
    }


    return (
        <LoginLayout loginTitle={loginTitle}
                     loginSubtitle={loginSubtitle}
                     textContent={textContent}
        >
            <LoginForm handleLogin={handleBasicLogin}
                       validCompany={validCompany}
                       setValidCompany={setValidCompany}
                       setUseAut0={ setUseAut0 }
            />
            <Auth0LogoutButton />
        </LoginLayout>
    );
};
